
<template>
  <div id="content" class="confirm_area">
    <div class="input_confirm">
      <ul>
        <li v-if="!isPrivateUser">
          <span>業種：</span>
          <span>{{corpTypeLabel}}</span>
        </li>
        <li v-if="!isPrivateUser">
          <span>所属部署：</span>
          <span>{{userForm.corpDept}}</span>
        </li>
        <li>
          <span>氏名：</span>
          <span>{{userForm.userLastName}} {{userForm.userFirstName}}</span>
        </li>
        <li>
          <span>氏名（カナ）：</span>
          <span>{{userForm.userLastNameKana}} {{userForm.userFirstNameKana}}</span>
        </li>
        <li v-if="!isEdit">
          <span>メールアドレス：</span>
          <span>{{userForm.email}}</span>
        </li>
        <li v-if="!isEdit">
          <span>パスワード：</span>
          <span>********</span>
        </li>
        <li v-if="!isEdit">
          <span>mm/styleをどこで知りましたか？：</span>
          <span>{{infosrcLabel}}</span>
        </li>
        <!-- <li v-if="false">
          <span>招待コード：</span>
          <span>{{userForm.inviteCode}}</span>
        </li> -->
        <li>
          <span>メールマガジンの受信：</span>
          <span>{{recvInfoLabel}}</span>
        </li>
      </ul>
      <div class="send_mail">※自動メールにて返信しますので、「@domans.co.jp」からのメールを受信許可に設定してください。</div>
    </div>
  </div>
</template>
<script>
import {CORP_TYPE, INFO_SRC} from '../../constants/TypeEc'
// Module

export default {
  name: 'UserConfirm',
  components: {
  },
  props: {
    userForm: Object,
    isPrivateUser: {
      type: Boolean,
      default: false
    },
    isEdit: Boolean
  },
  data () {
    return {
    }
  },
  computed: {
    corpTypeLabel: function () {
      if (this.userForm.corpType === undefined || this.userForm.corpType === '' || this.userForm.corpType === null) return ''
      return Object.keys(CORP_TYPE)
        .map(e => CORP_TYPE[e])
        .find(e => e.code === this.userForm.corpType)
        .label
    },
    infosrcLabel: function () {
      if (!this.userForm.infosrc) return ''
      return Object.keys(INFO_SRC)
        .map(e => INFO_SRC[e])
        .find(e => e.code === this.userForm.infosrc)
        .label
    },
    recvInfoLabel: function () {
      if (this.userForm.recvInfo === true) {
        return '受け取る'
      } else {
        return '受け取らない'
      }
    }
  },
  methods: {
  },
  created () {
  }
}
</script>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/user/DcUserConfirm.vue